<template>
  <aside class="left-sidebar">
    <!-- Sidebar scroll-->
    <div class="scroll-sidebar">
      <div class="user-profile px-3 hide-on-mini" v-if="isUserClient && !isWhiteLabel">
        <div class="card bg-light-extra mb-1">
          <div class="card-body py-3 px-2">
            <div class="text-center">
              <span v-for="(balance, index) in balances" :key="index">
                <span :class="{ 'text-danger': balance.balance < 0 }"
                      class="font-20">{{balance.balance | currency}}</span>
                <span v-if="balances.length > index+1">, </span>
              </span>
              <h6 class="mt-2 text-muted">account balance</h6>
            </div>
          </div>
        </div>
        <router-link v-if="isNoPayment"
                     tag="button"
                     class="btn waves-effect waves-light btn-block btn-danger mt-3"
                     :to="{ name: 'NewCard' }">
          Add Payment Card
        </router-link>
      </div>
      <nav class="sidebar-nav">
        <ul id="sidebarnav">
          <li class="nav-devider hide-on-mini" v-if="isUserClient && !isWhiteLabel"></li>
          <li v-for="menu in grantedMenu" :key="menu.name">
            <div class="nav-collapse" v-if="menu.child">
              <div class="holder">
                <b-btn v-b-toggle.reports>
                  <i class="mdi" :class="menu.icon"></i>
                  <span class="hide-menu">{{menu.name}}</span>
                </b-btn>
              </div>
              <b-collapse id="reports" :visible="isReportsPage">
                <router-link class="sub-link" v-for="child in menu.child" :key="child.name" :to="child.to">
                  <i class="mdi" :class="child.icon"></i>
                  <span class="hide-menu">{{child.name}}</span>
                </router-link>
              </b-collapse>
            </div>
            <router-link v-else-if="!isUserClient" :to="menu.to">
              <i class="mdi" :class="menu.icon"></i>
              <span class="hide-menu">{{menu.name}}</span>
            </router-link>
            <router-link v-else-if="isUserClient && !isWhiteLabel" :to="menu.to">
              <i class="mdi" :class="menu.icon"></i>
              <span class="hide-menu">{{menu.name}}</span>
            </router-link>
            <router-link v-else-if="isUserClient && isWhiteLabel && menu.showForWhiteLabel" :to="menu.to">
              <i class="mdi" :class="menu.icon"></i>
              <span class="hide-menu">{{menu.name}}</span>
            </router-link>
          </li>
          <li class="nav-devider"></li>
          <li v-for="menu in guides" :key="menu.name" v-if="!isWhiteLabel">
            <div class="nav-collapse" v-if="menu.child">
              <div class="holder">
                <b-btn v-b-toggle.guides>
                  <i class="mdi" :class="menu.icon"></i>
                  <span class="hide-menu">{{menu.name}}</span>
                </b-btn>
              </div>
              <b-collapse id="guides" :visible="isGuidesPage">
                <router-link class="sub-link" v-for="child in menu.child" :key="child.name" :to="child.to">
                  <i class="mdi" :class="child.icon"></i>
                  <span class="hide-menu">{{child.name}}</span>
                </router-link>
              </b-collapse>
            </div>
            <router-link v-else :to="menu.to">
              <i class="mdi" :class="menu.icon"></i>
              <span class="hide-menu">{{menu.name}}</span>
            </router-link>
          </li>
        </ul>
      </nav>
      <!-- End Sidebar navigation -->
    </div>
    <!-- End Sidebar scroll-->
    <!-- Bottom points-->
    <div class="sidebar-footer">
      <!-- item-->
      <a href="" class="link" @click.prevent="logout" data-toggle="tooltip" title="Logout">
        <i class="mdi mdi-power"></i>
      </a>
    </div>
    <!-- End Bottom points-->
  </aside>
</template>

<script>
  import {mapGetters} from 'vuex';

  const mainMenuList = [
    {
      name: 'Leads',
      to: '/leads',
      icon: 'mdi-account-multiple',
      granted: 'leads.find',
      showForWhiteLabel: true,
    },
    {
      name: 'Lead Search',
      to: '/search/lead',
      icon: 'mdi-account-search',
      granted: 'leads.search',
      showForWhiteLabel: true,
    },
    // {
    //   name: 'Tickets',
    //   to: '/tickets',
    //   icon: 'mdi-ticket-account',
    //   granted: 'tickets.find',
    //   showForWhiteLabel: true,
    // },
    {
      name: 'Users',
      to: '/users',
      icon: 'mdi-account-multiple',
      granted: 'users.find',
      showForWhiteLabel: true,
    },
    {
      name: 'Campaigns',
      to: '/campaigns',
      icon: 'mdi-group',
      granted: 'campaigns.find',
      showForWhiteLabel: false,
    },
    {
      name: 'Companies',
      to: '/companies',
      icon: 'mdi-briefcase',
      granted: 'companies.find',
      showForWhiteLabel: false,
    },
    {
      name: 'Reports',
      icon: 'mdi-folder-account',
      granted: 'reports.find',
      showForWhiteLabel: false,
      to: '',
      child: [
        {
          name: 'Agents',
          to: '/reports/agents',
          granted: 'reports.find',
          icon: 'mdi-chevron-right'
        }
      ],
    }
  ];

  const guidesMenuList = [{
    name: 'Guides',
    icon: 'mdi-lightbulb-outline',
    to: '',
    child: [
      {
        name: 'FAQs',
        to: {path: '/guides/6mIlYrimmIokCNGWyWZwxt'},
        icon: 'mdi-help'
      },
      {
        name: 'How-Tos',
        to: {path: '/guides/1DR0caf6Is8Q6CeIKKKKAy'},
        icon: 'mdi-book-multiple',
      },
      {
        name: 'Screens',
        to: {path: '/guides/4xsyJcaBK0gUgKsoci0qm2'},
        icon: 'mdi-image-filter'
      }
    ],
  }];

  export default {
    name: 'sidebar',
    data() {
      return {
        menus: mainMenuList,
        guides: guidesMenuList
      };
    },

    computed: {
      ...mapGetters(['getAuthUser', 'getCompanyBalances', 'isUserClient', 'getCompany', 'isWhiteLabel']),
      isReportsPage() {
        return /reports/gi.test(this.$route.path);
      },
      isGuidesPage() {
        return /guides/gi.test(this.$route.path);
      },
      user() {
        return this.getAuthUser;
      },
      balances() {
        return this.getCompanyBalances;
      },
      isNoPayment() {
        return !(this.getCompany && this.getCompany.stripeSourceId);
      },

      grantedMenu() {
        const menu = this.menus.filter(menuItem => this.$router.canSee([menuItem.granted]));
        const {
          companyId,
          role: {role_type: roleType},
        } = this.user;

        if (companyId && roleType === 'client') {
          menu.push({
            name: 'Company',
            to: `/companies/edit/${this.user.companyId}`,
            icon: 'mdi-city',
            granted: 'companies.update',
          });
        }
        return menu;
      },

      name() {
        if (this.user) {
          return this.user.name;
        }
      },

      photo() {
        if (this.user && this.user.photo) {
          return JSON.parse(this.user.photo);
        }
      },
    },

    methods: {
      logout() {
        this.$store.dispatch('logout');
        this.$router.replace('/login');
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .mini-sidebar .hide-on-mini {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue